import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";

@TypeManagerDecorator("s25-ng-org-invoice-actions-cell")
@Component({
    selector: "s25-ng-org-invoice-actions-cell",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent],
    template: `
        <div class="action-cell">
            @if (canSendEmail()) {
                <s25-ng-button
                    [type]="'outline'"
                    [ariaLabel]="emailLabel() + ': ' + invoiceNumber()"
                    [onClick]="onSendEmail()"
                    >{{ emailLabel() }}</s25-ng-button
                >
            }
            @if (canMarkPaid()) {
                <s25-ng-button
                    [type]="'outline'"
                    [ariaLabel]="'Mark as paid: ' + invoiceNumber()"
                    [onClick]="onMarkPaid()"
                    >Mark as Paid</s25-ng-button
                >
            }
            @if (!canSendEmail() && !canMarkPaid()) {
                <span class="muted">—</span>
            }
        </div>
    `,
    styles: `
        .action-cell {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
        }

        .muted {
            color: var(--color--text-muted);
        }
    `,
})
export class OrgInvoiceActionsCellComponent {
    readonly invoiceNumber = input("");
    readonly canSendEmail = input(false);
    readonly canMarkPaid = input(false);
    readonly hasOutstandingPayment = input(false);
    readonly onSendEmail = input<() => void>(() => {});
    readonly onMarkPaid = input<() => void>(() => {});

    protected readonly emailLabel = computed(() =>
        this.hasOutstandingPayment() ? "Send follow-up" : "Request payment",
    );
}
